var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState } from "react";
import { user } from "../../../store/auth/actions";
import { useDispatch } from "react-redux";
export var useFilters = function () {
    var dispatch = useDispatch();
    var _a = useState({
        enabled: true,
        deleted: false,
        roles: "",
        branch: "",
    }), filters = _a[0], setFilters = _a[1];
    var _b = useState(false), showSearch = _b[0], setShowSearch = _b[1];
    var _c = useState([]), defaultCheckedItemsActive = _c[0], setDefaultCheckedItemsActive = _c[1];
    var _d = useState([]), defaultCheckedItemsRol = _d[0], setDefaultCheckedItemsRol = _d[1];
    var _e = useState([]), defaultCheckedItemsBranch = _e[0], setDefaultCheckedItemsBranch = _e[1];
    var handleRolFilter = function (item) {
        setFilters(__assign(__assign({}, filters), { roles: item.id }));
        setDefaultCheckedItemsRol([item]);
        loadUsersByFilters(filters.enabled);
    };
    var handleBranchFilter = function (item) {
        setFilters(__assign(__assign({}, filters), { branch: item.id }));
        setDefaultCheckedItemsBranch([item]);
        loadUsersByFilters(filters.enabled);
    };
    var handleActiveFilter = function (item) {
        var value = item.id === "true";
        setFilters(__assign(__assign({}, filters), { enabled: value }));
        setDefaultCheckedItemsActive([item]);
        loadUsersByFilters(value);
    };
    var clearFilters = function () {
        setFilters(__assign(__assign({}, filters), { roles: "", branch: "", enabled: true }));
        setDefaultCheckedItemsRol([]);
        setDefaultCheckedItemsBranch([]);
        setDefaultCheckedItemsActive([]);
        loadUsersByFilters(true);
    };
    var handleShowSearch = function () {
        setShowSearch(!showSearch);
    };
    var loadUsersByFilters = function (status) {
        console.log("filters", filters);
        dispatch(user({
            orderBy: "createdAt",
            orderDir: "desc",
            enabled: status,
            page: 1,
            limit: 20,
            deleted: false,
            roles: filters.roles,
            branch: filters.branch,
        }));
    };
    return {
        handleRolFilter: handleRolFilter,
        handleBranchFilter: handleBranchFilter,
        defaultCheckedItemsRol: defaultCheckedItemsRol,
        defaultCheckedItemsBranch: defaultCheckedItemsBranch,
        handleActiveFilter: handleActiveFilter,
        defaultCheckedItemsActive: defaultCheckedItemsActive,
        clearFilters: clearFilters,
        showSearch: showSearch,
        setShowSearch: setShowSearch,
        handleShowSearch: handleShowSearch
    };
};
